import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'
import { Type } from 'class-transformer'
import TRoutingVariantOperationDM from './TRoutingVariantOperationDM'
import TResourceDM from './TResourceDM'
import TTextDM from './TTextDM'

export default class TRoutingVariantResourceDataFilterDM extends Data {
	public static className = 'TRoutingVariantResourceDataFilterDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	RoutingId?: number
	RoutingTypeId?: number
	RID?: number
	SequenceNumber?: number
	Quantity?: number
	NoteId?: number
	RecordMod?: number
	RecordES?: number
	RecordID?: number
	RecordState?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	@Type(() => TRoutingVariantOperationDM)
	RoutingOperationRID?: TRoutingVariantOperationDM
	@Type(() => TResourceDM)
	GroupId?: TResourceDM
	@Type(() => TResourceDM)
	ResourceId?: TResourceDM
	@Type(() => TTextDM)
	OperationTime?: TTextDM
}